import { useEffect, useState } from 'react';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { Auth } from 'aws-amplify';

// Small hook that reads the `seed-fridge-inventory` LaunchDarkly flag. Used by
// per-location tabs that want to surface a "Seed this fridge" entry point.
//
// Each consumer initializes its own LD client, matching the existing pattern
// in LocationsWrapperGraphQL and ViewHealth. Cheap enough that duplication is
// fine here — avoids threading the flag through childProps.

export default function useSeedInventoryFlag() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let ldclient;
    async function init() {
      try {
        const email =
          Auth?.user?.attributes?.email ||
          (await Auth.currentAuthenticatedUser()).signInUserSession.idToken
            .payload.email;
        ldclient = LDClient.initialize(
          process.env.REACT_APP_LAUNCH_DARKLY_CMS || 'nlfaepofjeowiajfpoijewr',
          { key: email },
        );
        ldclient.on('ready', () => {
          if (cancelled) return;
          const flags = ldclient.allFlags();
          setEnabled(!!flags['seed-fridge-inventory']);
        });
      } catch (e) {
        // Silently leave the button hidden if we can't initialize LD.
        // eslint-disable-next-line no-console
        console.warn('LD init failed for seed-fridge-inventory flag:', e);
      }
    }
    init();
    return () => {
      cancelled = true;
      if (ldclient && typeof ldclient.close === 'function') {
        ldclient.close();
      }
    };
  }, []);

  return enabled;
}
